<template>
  <v-form ref="form" autocomplete="off">
    <v-row>
      <v-col cols="12" lg="6">
        <v-text-field v-model="administrator.firstName" label="First Name" :rules="requiredRules" />
      </v-col>
      <v-col cols="12" lg="6">
        <v-text-field v-model="administrator.lastName" label="Last Name" :rules="requiredRules"/>
      </v-col>
    </v-row>
    <div v-if="administrator.id">
      <v-switch v-model="editPassword" label="Edit Password"/>
    </div>
    <div v-if="editPassword">
      <v-text-field type="password" v-model="administrator.password" label="Password" :rules="passwordRules"/>
      <v-text-field type="password" v-model="administrator.confirmPassword" label="Confirm Password" :rules="[passwordConfirmRule]" />
    </div>
    <v-text-field v-model="administrator.username" label="User Name" />
    <v-text-field v-model="administrator.email" label="Email" :rules="emailRules"/>
    <v-text-field v-mask="'+1(###) ###-####'" v-model="administrator.phone" label="Phone Number" />

    <v-select v-model="administrator.locations" multiple label="Authorized Locations" :items="locations"  :rules="requiredSelectRules" item-text="name" item-value="id"/>
    <v-checkbox v-model="administrator.internalUser"  label="Internal User" />

    <v-select v-model="userModules" label="User's module" multiple chips :items="availableModules" :rules="requiredSelectRules" item-text="name" item-value="id"/>
  </v-form>
</template>

<script>
import {mask} from 'vue-the-mask'
import { getAllModules } from "@/services/module";

export default {
  props: {
    administrator: {
      type: Object,
      required: true
    },
    locations: {
      type: Array,
      required: true
    },
  },
  directives: {mask},
  data: () => ({
    editPassword: false,
    requiredRules: [v => !!v || "This field is required"],
    requiredSelectRules: [v => v && v.length>0 || "This field is required"],
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    passwordRules: [
      v => !!v || "Password is required",
      v => (v && v.length >= 6) || "Passowrd must be at least 6 characters"
    ],
    userModules: [],
    availableModules: [],
  }),
  watch:{
    editPassword(val){
      this.administrator['changePassword'] = val;
    },
    userModules(val){
      this.administrator.moduleIds = val;
    }
  },
  computed: {
    passwordConfirmRule(){
      return () => (this.administrator.password === this.administrator.confirmPassword) || 'Password must match'
    }
  },
  created(){
    this.editPassword = this.administrator && this.administrator.id ? false:true;
    this.administrator['changePassword'] = this.editPassword;

    this.loadAccountModules().then(() => {
      this.loadUserModules();
    });
  },
  methods: {
    loadUserModules() {
      if(this.administrator && this.administrator.id){
        this.$axios("/user/module", { params: { user_id: this.administrator.id } }).then(
          (resp) => {
            const userMods = resp.data;
            if (userMods) {
              this.userModules = userMods.map((m) => m.id);
            }
          }
        );
      }
    },
    async loadAccountModules() {

      const params = { 
        pageIndex: 0,
        pageSize: 100
      }
      getAllModules(params).then((response) => {
        this.availableModules = response.data.content;
        return this.availableModules;
      });
      
    },
  }
};
</script>

<style>
</style>